"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    fieldWrapper: {
        marginBottom: 20
    },
    field: {
        marginBottom: 3
    },
    rawDescription: {
        fontSize: 12
    },
    rawHelp: {
        fontSize: 12
    },
    labelWrapper: {
        paddingBottom: 8,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
        backgroundColor: 'inherit'
    },
    label: {
        color: theme.grey1,
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: 0,
        '&[data-input-is-required="true"]::after': {
            content: '" *"',
            color: theme.warningRed
        },
        '&[data-is-large="true"]': {
            flexGrow: 1
        }
    },
    lockIconClose: {
        // extend: iconStyle,
        marginLeft: 5,
        color: theme.grey5,
        '&[data-is-clickable="true"]': {
            color: theme.grey1,
            cursor: 'pointer'
        }
    },
    lockIconOpen: {
        // extend: iconStyle,
        marginLeft: 5,
        color: theme.grey4,
        cursor: 'pointer'
    },
    linkIcon: {
        // extend: iconStyle,
        color: theme.indigo3,
        cursor: 'pointer'
    },
    unlinkIcon: {
        // extend: iconStyle,
        color: theme.grey1,
        cursor: 'pointer'
    }
});
//# sourceMappingURL=field.style.js.map